/*   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect, useState } from "react";
import "react-responsive-modal/styles.css";
import { Modal, ModalBody, ModalFooter, ModalHeader, Button, InputGroup, Input } from "reactstrap";
import { EventBusModule } from "@vlinder-web/event-bus-module-react";
import * as S from "./styles";
import { useTimer } from "react-timer-hook";

export const STATE_VC_MODAL_OPEN = "StateVCModalVW:Open";
export const STATE_VC_MODAL_CLOSE = "StateVCModalVW:Close";
export const STATE_VC_MODAL_TIMER_EXPIRY = "StateVCModalVW:Expiry";
export const STATE_VC_MODAL_OPEN_SUCCESS = "StateVCModalVW:OpenSuccess";
export const STATE_VC_MODAL_CLOSE_SUCCESS = "StateVCModalVW:CloseSuccess";
export const STATE_VC_MODAL_SUBMIT = "StateVCModalVW:Accept";
export const STATE_VC_MODAL_REJECTED = "StateVCModalVW:Reject";

export interface IStateVCModalProps {
    open?: boolean;
}

const MODAL_ITEMS = {
    open: false,
    currentID: null,
    title: null,
    image: null,
    width: null,
    height: null,
    description: null,
    expiry: null,
};

export const StateVCModalVW = (props: IStateVCModalProps) => {
    const eb = EventBusModule.getInstance().getEventBus();
    const [item, setItem] = useState(MODAL_ITEMS);
    const [inputData, setInputData] = useState<string>();

    const time = new Date();
    time.setSeconds(time.getSeconds() + 60);
    const onTimerExpiry = () => {
        eb.emit(STATE_VC_MODAL_TIMER_EXPIRY, null, {});
        onModalClose();
    };
    const { seconds, minutes, hours, days, restart, isRunning, pause } =
        useTimer({
            expiryTimestamp: time,
            autoStart: false,
            onExpire: onTimerExpiry,
        });
    // debugger;

    useEffect(() => {
        _subscribe();
        return _unsubscribe;
    });

    const _subscribe = () => {
        eb.on(STATE_VC_MODAL_OPEN, onModalOpen);
        eb.on(STATE_VC_MODAL_CLOSE, onModalClose);
    };

    const _unsubscribe = () => {
        eb.off(STATE_VC_MODAL_OPEN, onModalOpen);
        eb.off(STATE_VC_MODAL_CLOSE, onModalClose);
    };

    const onModalOpen = (props: any) => {
        if (item.open === false) {
            if (props.expiry) {
                const time = new Date();
                time.setSeconds(time.getSeconds() + props.expiry);
                restart(time);
                eb.emit(STATE_VC_MODAL_OPEN_SUCCESS, null, {});
            }
            setItem({
                open: true,
                ...{ ...(props || {}) },
            });
        }
    };

    const onModalClose = () => {
        if (item.open) {
            if (isRunning) {
                pause();
            }
            setItem({
                ...MODAL_ITEMS,
                open: false,
            });

            eb.emit(STATE_VC_MODAL_CLOSE_SUCCESS, null, {});
            eb.emit(STATE_VC_MODAL_REJECTED, null, {});
        }
    };

    const onModalAccept = () => {
        if (item.open) {
            if (isRunning) {
                pause();
            }
            setItem({
                ...MODAL_ITEMS,
                open: false,
            });
            eb.emit(STATE_VC_MODAL_SUBMIT, null, {voucher: inputData});
            eb.emit(STATE_VC_MODAL_CLOSE_SUCCESS, null, {});
        }
    };

    const onModalReject = () => {
        if (item.open) {
            if (isRunning) {
                pause();
            }
            setItem({
                ...MODAL_ITEMS,
                open: false,
            });
            eb.emit(STATE_VC_MODAL_REJECTED, null, {});
            eb.emit(STATE_VC_MODAL_CLOSE_SUCCESS, null, {});
        }
    };

    const _renderTitle = () => {
        if (item.title) {
            return <S.Title>{item.title}</S.Title>;
        }
    };

    const _renderImage = () => {
        if (item.image) {
            return (
                <S.Image
                    src={item.image}
                    width={item.width ?? "30%"}
                    height={item.height ?? "auto"}
                />
            );
        }
    };

    const onInputChange = (e:any)=>{
        console.log('input value change', e);
        setInputData(e?.target?.value);
    }

    const _renderInput = () =>{
        return (
            <InputGroup>
            <Input type="text" name="voucherCode" value={inputData} onChange={onInputChange}/>
            </InputGroup>
            
        )
    }

    const _renderDescription = () => {
        if (item.description) {
            return (
                <S.Description>
                    {item.description}
                </S.Description>
            );
        }
    };

    const _renderBody = () => {
        return (
            <S.Container>
                {_renderInput()}
                {/* {_renderImage()} */}
                {_renderDescription()}
                {/* {_renderTimer()} */}
            </S.Container>
        );
    };

    const _renderButtons = () => {
        return (
            <>
                <Button onClick={() => onModalReject()}>Close</Button>{" "} 
                <Button color="primary" onClick={() => onModalAccept()}>
                    Submit
                </Button>               
            </>
        );
    };

    const _getModal = () => {
        if (item?.open) {
            return (
                <Modal
                    isOpen={item?.open}
                    toggle={onModalClose}
                    fullwidth={true}
                    size={"md"}
                    centered={true}
                    animation={false}
                    fade={false}
                    style={{ width: "100%" }}
                >
                    <ModalHeader toggle={onModalClose}>{_renderTitle()}</ModalHeader>
                    <ModalBody>{_renderBody()}</ModalBody>
                    <ModalFooter>{_renderButtons()}</ModalFooter>
                </Modal>
            );
        }
    };

    return <>{_getModal()} </>;
};
